import { Button, Divider, message, Space, Table, Tag } from 'antd';
import React, { useEffect, useState } from 'react';
import ManageBinService from '../../../../../services/Dispatch-Centre-Service/ManageBinService';
import ResponseMessage from '../../../../Comman/Notification/ResponseMessge';
import {useNavigate } from 'react-router';

const BulkOutwardPreview = () => {
    const [formatedBinId, setFormatedBinId] = useState([]);
    const [binData, setBinData] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchBinData = async () => {
            try {
                const storedBinIds = JSON.parse(localStorage.getItem("bin_bulk_outward")) || [];
                console.log(storedBinIds);

                if (Array.isArray(storedBinIds)) {
                    const binIdsArray = storedBinIds.map(bin => bin.bin_id);
                    setFormatedBinId(binIdsArray);
                    console.log(binIdsArray);
                    const response = await ManageBinService.getBulkBinData(binIdsArray);

                    if (response?.message) {
                        console.log(response.message);
                        // message.success(response.message);
                        ResponseMessage.success({ message: response.message });

                        const processedData = processBinData(response.data);
                        setBinData([processedData]);
                    } else {
                        ResponseMessage.error({ message :"No response message from the server."});
                        
                    }
                } else {
                    console.log('No valid bin data found.');
                }


                if (storedBinIds.length === 0) {
                    message.warning('No Bin IDs found in local storage.');
                    return;
                }


            } catch (error) {
                console.error("Error fetching bin data:", error);
                ResponseMessage.error({ message :"Failed to fetch bin data."});
            }
        };

        fetchBinData();
    }, []);

    const processBinData = (binData) => {
        if (!Array.isArray(binData)) {
            console.error("processBinData: binData is not an array", binData);
            return [];
        }

        const uniqueBins = new Set();
        const uniqueKanban = new Set();
        const uniqueItemNos = new Set();
        const uniqueColors = new Set();
        const sizeQtyMap = {};
        let totalPcs = 0;

        binData.forEach(bin => {
            if (!bin || !Array.isArray(bin.bin_data)) return;
            uniqueBins.add(bin.bin_id);
            bin.bin_data.forEach(data => {
                uniqueKanban.add(data.kanban_no);
                uniqueItemNos.add(data.item_no);
                if (data.color) {
                    data.color.split("/").forEach(color => uniqueColors.add(color.trim()));
                }

                if (data.size_qty) {
                    try {
                        const sizeQty = JSON.parse(data.size_qty);
                        Object.entries(sizeQty).forEach(([size, qty]) => {
                            sizeQtyMap[size] = (sizeQtyMap[size] || 0) + parseInt(qty, 10);
                            totalPcs += parseInt(qty, 10);
                        });
                    } catch (error) {
                        console.error("Error parsing size_qty", data.size_qty);
                    }
                }
            });
        });

        return {
            key: "summary",
            item_no: Array.from(uniqueItemNos),
            color: Array.from(uniqueColors),
            size_qty: sizeQtyMap,
            total_bins: uniqueBins.size,
            total_kanban: uniqueKanban.size,
            total_pcs: totalPcs
        };
    };

    const columnsHori = [
        {
            title: "Property",
            dataIndex: "property",
            key: "property",
        },
        {
            title: "Value",
            dataIndex: "value",
            key: "value",
            render: (value) => (
                <Space>
                    {Array.isArray(value) ? (
                        value.map((item, index) => (
                            <Tag color="blue" key={index}>
                                {item}
                            </Tag>
                        ))
                    ) : typeof value === 'object' ? (
                        Object.entries(value).map(([size, qty]) => (
                            <Tag color="red" key={size}>
                                {size} : {qty}
                            </Tag>
                        ))
                    ) : (
                        value
                    )}
                </Space>
            ),
        },
    ];

    const horizontalData = binData.map((data) => [
        { property: "Item", value: data.item_no },
        { property: "Color", value: data.color },
        { property: "Size and Qty", value: data.size_qty },
    ]);
    const flattenedData = horizontalData.flat();

    const handleConfirmBinOutward = async () => {
        const userData = JSON.parse(localStorage.getItem("userData"));
        const addedBy = userData?.data?.su_id;

        const response = await ManageBinService.BulkOutward(formatedBinId, addedBy);
       
        console.log(response); 
        
        ResponseMessage.success(response.message);
        localStorage.removeItem('bin_bulk_outward');
        navigate('/manage-bin');
    };

    return (
        <>
            <Space size={"small"}>
                <Tag color="blue" style={{ fontSize: "20px", padding: "10px" }}>
                    Total Bins: {binData[0]?.total_bins || 0}
                </Tag>
                <Tag color="green" style={{ fontSize: "20px", padding: "10px" }}>
                    Total Kanban: {binData[0]?.total_kanban || 0}
                </Tag>
                <Tag color="red" style={{ fontSize: "20px", padding: "10px" }}>
                    Total Pcs: {binData[0]?.total_pcs || 0}
                </Tag>
            </Space>
            <Divider />
            {/* <Table columns={columns} dataSource={binData} pagination={false} bordered /> */}
            <Table columns={columnsHori}
                dataSource={flattenedData}
                pagination={false}
                showHeader={false}
                bordered />

            <Button
                type="primary"
                danger
                size="large"
                style={{
                    position: 'fixed',
                    bottom: '24px',
                    right: '26px',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
                    width: '20%',
                }}
                onClick={handleConfirmBinOutward}
            >Confirm</Button>
        </>
    );
};

export default BulkOutwardPreview;
